import classNames from 'classnames';
import Menu from './Menu';

type SidebarProps = {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  className?: string;
}

const Sidebar = ({collapsed, setCollapsed, className}: SidebarProps) => {

  return (
    <div data-name="SideBar" className={classNames(
      'flex flex-col h-full shrink-0 grow-0 relative transition-all @container z-10',
      className,
      {
        'w-64': collapsed === false,
        'w-20': collapsed === true,
      }
    )}>
      <div className="absolute bg-white p-1.5 size-8 rounded-full shadow-down-sm top-16 z-10 -right-10" onClick={() => setCollapsed(!collapsed)}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.7779 6.2094C6.48178 5.9302 6.00342 5.9302 5.70729 6.2094L2.2221 9.4953C1.92597 9.7745 1.92597 10.2255 2.2221 10.5047L5.70729 13.7906C6.00342 14.0698 6.48178 14.0698 6.7779 13.7906C7.07403 13.5114 7.07403 13.0604 6.7779 12.7812L3.83181 9.99642L6.7779 7.21879C7.07403 6.9396 7.06644 6.48143 6.7779 6.2094Z" fill="#959CC0"/>
          <path d="M13.2221 13.7906C13.5182 14.0698 13.9966 14.0698 14.2927 13.7906L17.7779 10.5047C18.074 10.2255 18.074 9.7745 17.7779 9.4953L14.2927 6.2094C13.9966 5.9302 13.5182 5.9302 13.2221 6.2094C12.926 6.48859 12.926 6.9396 13.2221 7.21879L16.1682 10.0036L13.2221 12.7812C12.926 13.0604 12.9336 13.5186 13.2221 13.7906Z" fill="#959CC0"/>
        </svg>
      </div>
      <Menu />
    </div>
  );
};

export default Sidebar;
